{
  "community": {
    "title": "Comunidad - MAJORITY",
    "description": "Conoce la comunidad MAJORITY, con montones de artículos sobre cómo ahorrar dinero y generar riqueza en los EUA, ¡así como eventos interesantes y más!",
    "labels": {
      "majority_community": "Majority Community",
      "all": "Todo",
      "popular": "Popular",
      "events": "Eventos",
      "event": "Evento",
      "article": "Artículo",
      "category": "Categoría",
      "tags": "Etiquetas",
      "share": "Compartir",
      "search_placeholder": "Escribe tu término de búsqueda...",
      "load_more": "Cargar más",
      "related_articles": "Artículos relacionados",
      "related_events": "Eventos relacionados",
      "related_discounts": "Descuentos relacionados",
      "where": "Dónde",
      "when": "Cuándo",
      "welcome_one": "Bienvenido uno",
      "welcome_all": "Bienvenido todos",
      "see_articles_for": "Ver artículos de"
    },
    "error": {
      "no_content": "¡Lo sentimos! Seguimos trabajando para agregar más contenido a la Comunidad."
    }
  }
}